import axios from "axios";

export default axios.create({
  baseURL: "https://saveramericas.com/wp-json/api/v2",
  // baseURL: "https://saveramericas.360southclients.com/wp-json/api/v2",
});
